/**
 * Filler answers ride a uniform `{ value: <raw> }` envelope (see
 * `useElementValue` in the UI packages). Several readers — formStats,
 * the logic evaluator, the entity pickers' cross-element value lookup —
 * need to peel the envelope before inspecting the bare answer.
 *
 * The envelope is identified by a plain object with exactly one key
 * called `value`. Anything else passes through unchanged so non-envelope
 * values (legacy drafts, configForm bare values, ...) keep working
 * without conditional branches at every call site.
 */
export const unwrapEnvelope = (raw: unknown): unknown => {
  if (
    raw !== null &&
    typeof raw === "object" &&
    !Array.isArray(raw) &&
    "value" in (raw as Record<string, unknown>) &&
    Object.keys(raw as Record<string, unknown>).length === 1
  ) {
    return (raw as { value: unknown }).value;
  }
  return raw;
};

/** Wrap a raw answer in the canonical envelope shape. */
export const wrapEnvelope = (value: unknown): { value: unknown } => ({ value });
